export default __webpack_public_path__ + "static/media/hide-visible.e90afa6e.svg";